import React from "react";

import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";
import { IncomingLiveEventsBannerView } from "./esport-incoming-events-banner/view";
import { FullscreenEntryContainer } from "supercell-frontend-base/src/components/fullscreen-entry";

import styles from "./styles.modules.scss";
import { ContentfulSocialLinks } from "supercell-frontend-base/src/components/contentful-social-links";
import { EsportCarousel } from "supercell-frontend-base/src/components/esport/esport-carousel";
import { EsportCarouselControllerView } from "./esport-carousel/view";
import {
    Cta,
    EsportSlide,
    LiveSlide,
} from "supercell-frontend-base/src/components/esport/types";
import { IncomingLiveEventsBanner } from "supercell-frontend-base/src/components/esport/esport-incoming-events-banner";
import { filterNewsFeed } from "supercell-frontend-base/src/utils/filter-news-feed";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";
import { useLocation } from "react-router-dom";

export const EsportView = ({ filterArticles }: { filterArticles: any }) => {
    const { trackPageView } = useSnowplowContext();
    const { pathname: pagePath } = useLocation();

    React.useEffect(() => {
        trackPageView("Esport", pagePath);
        window.history.pushState({ home: true }, "");
    }, []);

    return (
        <Tab namespace="esport">
            {({
                data: {
                    articles,
                    carouselItems,
                    socialLinks,
                    fullscreenEntries,
                },
                locale,
            }) => {
                const filteredArticles = filterArticles(articles);

                const carouselItemsWithoutInvalidLinks = carouselItems.map(
                    (c: EsportSlide) => {
                        const isValidCtaButton = (c?: Cta) => {
                            if (!c) {
                                return false;
                            }

                            if (c.type === "url") {
                                return true;
                            }

                            if (c.type === "bridgeFunction") {
                                return true;
                            }

                            const articleId = c.url.id;

                            const matchingArticle = filteredArticles.find(
                                (a: any) => a.id === articleId,
                            );

                            if (!matchingArticle) {
                                return false;
                            }

                            return true;
                        };

                        if (c.type === "liveEntry") {
                            const isReadMoreValid = isValidCtaButton(
                                c.readMoreButton,
                            );

                            return isReadMoreValid
                                ? c
                                : {
                                      ...c,
                                      readMoreButton: undefined,
                                  };
                        }

                        const buttons = c.ctaButtons?.filter(isValidCtaButton);

                        return {
                            ...c,
                            ctaButtons: buttons,
                        };
                    },
                );

                const visibilityFilteredArticles = filteredArticles.filter(
                    (a) => filterNewsFeed(a),
                );

                return (
                    <FullscreenEntryContainer
                        entries={fullscreenEntries}
                        tab="esport"
                    >
                        <div className={`esport ${styles.esport}`}>
                            <Grid>
                                <div className={`articles ${styles.articles}`}>
                                    <List
                                        header={
                                            <>
                                                <IncomingLiveEventsBanner
                                                    view={
                                                        IncomingLiveEventsBannerView
                                                    }
                                                    slides={
                                                        carouselItemsWithoutInvalidLinks as LiveSlide[]
                                                    }
                                                />

                                                <EsportCarousel
                                                    view={
                                                        EsportCarouselControllerView
                                                    }
                                                    locale={locale}
                                                    slides={
                                                        carouselItemsWithoutInvalidLinks as EsportSlide[]
                                                    }
                                                />
                                            </>
                                        }
                                        Item={ListArticle}
                                        items={visibilityFilteredArticles}
                                        columns={2}
                                        perPage={4}
                                        footer={
                                            <ContentfulSocialLinks
                                                links={socialLinks}
                                            />
                                        }
                                    />
                                </div>
                            </Grid>
                        </div>
                    </FullscreenEntryContainer>
                );
            }}
        </Tab>
    );
};
